import { Typography, useMediaQuery } from "@material-ui/core";
import { makeStyles } from "@material-ui/core/styles";
import React from "react";

const useStyles = makeStyles((theme) => ({
  subHeading1: {
    display: "flex",
    flexDirection: "row",
    justifyContent: "space-between",
    color: "#000000",
    fontWeight: 400,
    alignItems: "center",
    fontSize: "1rem",
    lineHeight: "1.688rem",
    margin: "0.5rem 0rem 0rem 0rem",
    background: "#FAFAFA",
    padding: "0.5rem 1rem",
    borderRadius: "1rem",
  },
  subHeading: {
    fontSize: "1rem",
    lineHeight: "1.688rem",
    color: "#212121",
    [theme.breakpoints.down("sm")]: {
      fontSize: "0.875rem",
      fontWeight: 400,
      lineHeight: "1.25rem",
    },
  },
}));

const SchoolVicinity = () => {
  const classes = useStyles();
  const isMobile = useMediaQuery((theme) => theme.breakpoints.down("sm")); // Detect mobile devices

  const schools = [
    { name: "National Public School", distance: "1 KM" },
    { name: "JSS Public School", distance: "2.4 KM" },
    { name: "Cambridge High School", distance: "4.8 KM" },
    { name: "Christ University", distance: "7 KM" },
  ];

  const displayedSchools = isMobile ? schools.slice(0, 4) : schools;

  return (
    <React.Fragment>
      {displayedSchools.map((school, index) => (
        <div
          className={classes.subHeading1}
          key={index}
        >
          <Typography className={classes.subHeading}>{school.name}</Typography>
          <Typography className={classes.subHeading}>{school.distance}</Typography>
        </div>
      ))}
    </React.Fragment>
  );
};

export default SchoolVicinity;
